import store from '@/store/index'
import * as fleetMarkers from '@/maps/google/fleetMarkers'
import * as googleMaps from '@/common/googleMaps'

export default {}

/**
 * Returns the full state object of the vehicle widget module.
 *
 * @returns Object
 */
export const get = () => {
  return store.getters['monitoring/fleetWidgetModule/get']
}

/**
 * Returns either a client object or null depending on whether
 * queries should be made by client.
 *
 * @return Object|null
 */
export const getClient = () => {
  return store.getters['monitoring/fleetWidgetModule/getClient']
}

export const getVehicles = () => {
  return store.getters['monitoring/fleetWidgetModule/getVehicles']
}

export const getSelectedVehicleId = () => {
  return store.getters['monitoring/fleetWidgetModule/getSelectedVehicleId']
}

export const getFleetOptionsOpen = () => {
  return store.getters['monitoring/fleetWidgetModule/getFleetOptionsOpen']
}

/**
 * Load the vehicle's.
 *
 * @return Promise
 */
export const query = () => {
  return store.dispatch('monitoring/fleetWidgetModule/query')
}

/**
 * Clears all vehicle's from being listed.
 */
export const purge = () => {
  store.commit('monitoring/fleetWidgetModule/purge')
}

export const queryVehicleGroups = () => {
  return store.dispatch('monitoring/fleetWidgetModule/queryVehicleGroups')
}

/**
 * Sets the client for which the vehicle's should be queried.
 *
 * @param client Object|null
 */
export const setClient = (client) => {
  store.commit('monitoring/fleetWidgetModule/setClient', client)
}

export const setSelectedVehicleId = (vehicleId) => {
  store.commit('monitoring/fleetWidgetModule/setSelectedVehicleId', vehicleId)
}

export const setFleetOptionsOpen = (open) => {
  store.commit('monitoring/fleetWidgetModule/setFleetOptionsOpen', open)
}

export const buildVehIdentification = (vehicle, options, includeMakeModel = false) => {
  let vehIdent = []

  if (options.showRegNo) vehIdent.push(vehicle.reg_no)
  if (options.showFleetNo && vehicle.fleet_no) vehIdent.push(vehicle.fleet_no)
  if (includeMakeModel) {
    if (options.showVehMakeModel && vehicle.vehicle_make) vehIdent.push(vehicle.vehicle_make)
    if (options.showVehMakeModel && vehicle.vehicle_model) vehIdent.push(vehicle.vehicle_model)
  }
  if (vehIdent.length === 0) vehIdent.push(vehicle.reg_no)
  if (options.showDriver && vehicle.driver_name) vehIdent.push(vehicle.driver_name)

  return vehIdent.join(' - ')
}

export const updateVehicleLabels = () => {
  const options = get().options
  const latestVehicleIds = new Map()

  getVehicles().forEach((vehicle) => {
    latestVehicleIds.set(vehicle.id, true)
    fleetMarkers.setFleetMarker(
      googleMaps.map, vehicle.id, vehicle, buildVehIdentification(vehicle, options), { offsetY: -10 })
  })

  fleetMarkers.removeDetachedMarkers(latestVehicleIds)
  fleetMarkers.updateMarkerCluster()
}



// WEBPACK FOOTER //
// ./src/store/monitoring/fleetWidget.helpers.js